import type OlMap from 'ol/Map'

import VectorImageLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { setLayerMetadata } from '../layerMetadata'

import { LineString, MultiLineString } from 'ol/geom'
import {
  collectDirectionIconsFromFeatures,
  directionManager,
  drawAllDirectionIcons,
  pathStyle,
} from './utils/breadcrumbAndRoutePath/getPathFeatureStyle'

export const createBreadcrumbAndRoutePolylineLayers = (map: OlMap) => {
  // Breadcrumb path layer
  const breadcrumbPathAndRoutePolylineLayer = new VectorImageLayer<
    VectorSource<LineString | MultiLineString>
  >({
    source: new VectorSource(),
    style: pathStyle,
  })

  setLayerMetadata(breadcrumbPathAndRoutePolylineLayer, 'uid', 'breadcrumbPathAndRoutePolyline')

  breadcrumbPathAndRoutePolylineLayer.on('postrender', event => {
    const ctx = event.context as CanvasRenderingContext2D
    const frameState = event.frameState

    if (ctx && frameState) {
      const pixelRatio = frameState.pixelRatio
      // Retrive all features and collect direction icons
      collectDirectionIconsFromFeatures(pixelRatio, breadcrumbPathAndRoutePolylineLayer)
      // Draw all collected direction icons
      drawAllDirectionIcons(ctx, pixelRatio)
    }

    // Clean up direction manager for next render cycle
    directionManager.clear()
  })

  map.addLayer(breadcrumbPathAndRoutePolylineLayer)

  // Breadcrumb points layer
  const pointsLayer = new VectorImageLayer<VectorSource>({
    source: new VectorSource(),
    minZoom: 14,
  })

  setLayerMetadata(pointsLayer, 'uid', 'breadcrumbPoints')

  map.addLayer(pointsLayer)
}
